var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyboardDoubleArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 151,
    viewBox: "0 0 150 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.626 39.4374C33.1885 41.8749 33.1885 45.8124 35.626 48.2499L59.876 72.4999L35.626 96.7499C33.1885 99.1874 33.1885 103.125 35.626 105.562C38.0635 108 42.001 108 44.4385 105.562L73.126 76.8749C75.5635 74.4374 75.5635 70.4999 73.126 68.0624L44.501 39.4374C42.0635 36.9999 38.0635 36.9999 35.626 39.4374Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8127 39.4376C74.3752 41.8751 74.3752 45.8126 76.8127 48.2501L101.063 72.5001L76.8127 96.7501C74.3752 99.1876 74.3752 103.125 76.8127 105.563C79.2502 108 83.1877 108 85.6252 105.563L114.313 76.8751C116.75 74.4376 116.75 70.5001 114.313 68.0626L85.6252 39.3751C83.2502 37.0001 79.2502 37.0001 76.8127 39.4376Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardDoubleArrowRight);
export default __webpack_public_path__ + "static/media/keyboard_double_arrow_right.b2ec6fdb.svg";
export { ForwardRef as ReactComponent };